// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2xSaI","vLegacy":"SelectSecondary_vLegacy__1u9q5","error":"SelectSecondary_error__3KuBI","disabled":"SelectSecondary_disabled__32YKb"};